import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  progressHeader: {
    marginBottom: theme.spacing(2),
  },
  progressLabel: {
    fontSize: 14,
    fontWeight: 600,
    color: theme.palette.text.primary,
    marginBottom: theme.spacing(1),
  },
  stepsRow: {
    display: 'flex',
    gap: theme.spacing(0.5),
  },
  step: {
    height: 4,
    flex: 1,
    borderRadius: 2,
    backgroundColor: theme.palette.divider,
  },
  stepActive: {
    backgroundColor: theme.palette.common.black,
  },
  stepAnswered: {
    backgroundColor: theme.palette.common.black,
    opacity: 0.45,
  },

  questionCard: {
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: theme.shape.borderRadius,
    padding: theme.spacing(3),
    backgroundColor: theme.palette.background.paper,
  },
  questionStatement: {
    fontSize: 15,
    fontWeight: 400,
    color: theme.palette.text.primary,
    lineHeight: 1.6,
    marginBottom: theme.spacing(2.5),
    wordBreak: 'break-word',
    overflowWrap: 'anywhere',
  },

  multipleCorrectHint: {
    fontSize: 13,
    marginBottom: theme.spacing(1.5),
    fontStyle: 'italic',
  },

  alternativesList: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1),
    marginBottom: theme.spacing(3),
  },
  alternativeRow: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: theme.spacing(1.5),
    padding: theme.spacing(1.5, 2),
    borderRadius: theme.shape.borderRadius,
    border: `1px solid ${theme.palette.divider}`,
    cursor: 'pointer',
    userSelect: 'none',
    transition: 'border-color 0.15s, background-color 0.15s',
    '&:hover': {
      borderColor: theme.palette.grey[900],
      backgroundColor: theme.palette.grey[400],
    },
    '&$alternativeRowSelected': {
      borderColor: theme.palette.common.black,
      backgroundColor: theme.palette.grey[900],
    },
  },
  alternativeRowSelected: {},
  alternativeLetter: {
    fontFamily: theme.typography.fontFamily,
    width: 30,
    height: 30,
    minWidth: 30,
    borderRadius: '50%',
    border: `2px solid ${theme.palette.divider}`,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: 13,
    fontWeight: 700,
    color: theme.palette.common.black,
    flexShrink: 0,
    transition: 'border-color 0.15s, background-color 0.15s, color 0.15s',
    '&$alternativeLetterSelected': {
      borderColor: theme.palette.common.black,
      backgroundColor: theme.palette.common.white,
      color: theme.palette.common.black,
    },
  },
  alternativeLetterSelected: {},
  alternativeContent: {
    fontSize: 14,
    color: theme.palette.text.primary,
    lineHeight: 1.5,
    paddingTop: 5,
    wordBreak: 'break-word',
    overflowWrap: 'anywhere',
    '&$alternativeContentSelected': {
      color: theme.palette.common.white,
    },
  },
  alternativeContentSelected: {},
  navigation: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    paddingTop: theme.spacing(1),
    borderTop: `1px solid ${theme.palette.divider}`,
  },
  prevButton: {
    textTransform: 'none',
    fontWeight: 500,
    color: theme.palette.text.secondary,
    padding: theme.spacing(0, 3),
    '@media (max-width: 384px)': {
      '& .MuiButton-startIcon': {
        display: 'none',
      },
    },
  },
  nextButton: {
    textTransform: 'none',
    fontWeight: 700,
    backgroundColor: theme.palette.common.black,
    color: theme.palette.white,
    paddingLeft: theme.spacing(3),
    paddingRight: theme.spacing(3),
    '&:disabled': {
      backgroundColor: theme.palette.divider,
      color: theme.palette.text.secondary,
    },
    '&:hover': {
      backgroundColor: theme.palette.common.black,
      opacity: 0.8,
    },
    '@media (max-width: 384px)': {
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2),
      '& .MuiButton-endIcon': {
        display: 'none',
      },
    },
  },
  buttonTextFull: {
    '@media (max-width: 384px)': {
      display: 'none',
    },
  },
  buttonTextShort: {
    display: 'none',
    '@media (max-width: 384px)': {
      display: 'inline',
    },
  },
}))

export default useStyles
